import type { CSSProperties, ReactNode } from "react";
import cx from "ui/cx";
import styles from "./StudioPlaceholderMessage.module.scss";

interface StudioPlaceholderMessageProps {
  children: string | ReactNode;
  style?: CSSProperties;
  className?: string;
}

export default function StudioPlaceholderMessage({ children, style, className }: StudioPlaceholderMessageProps) {
  return (
    <div className={cx(styles.wrapper, className)} style={style}>
      {children}
    </div>
  );
}

interface StudioNoSearchResultsPlaceholderMessageProps {
  search: string;
  filtersApplied?: boolean;
  style?: CSSProperties;
}

export function StudioNoSearchResultsPlaceholderMessage({
  search,
  filtersApplied,
  style,
}: StudioNoSearchResultsPlaceholderMessageProps) {
  return (
    <div className={styles.noSearchResultsWrapper} style={style}>
      No results found for{" "}
      {search && (
        <span className={styles.searchTerm}>
          <q>{search}</q>
        </span>
      )}
      {filtersApplied && <span>applied filters</span>}
    </div>
  );
}
